/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useMemo } from 'react';
import { Box } from '@apia/theme';
import { TResponsiveTableCellRendererProps } from '../types';
import { AutoEllipsis } from '@apia/components';
import { useResponsiveTableContext } from '../ResponsiveTableContext';

const NoMemoDefaultCellRenderer = React.forwardRef<
  HTMLTableCellElement,
  TResponsiveTableCellRendererProps
>(
  (
    {
      cell: { Renderer, rendererProps, AccordionRenderer, ariaLabel, ...cell },
      column,
      row,
      ...props
    },
    currentRef,
  ) => {
    const { avoidAutoEllipsis } = useResponsiveTableContext();
    return (
      <Box
        as={'td' as any}
        sx={useMemo(
          () => ({
            '&.colored': {
              background: cell.background,
              color: cell.color,
              fontWeight: 'bold',
            },
          }),
          [cell.background, cell.color],
        )}
        ref={currentRef as React.RefObject<HTMLTableCellElement>}
        {...props}
        {...cell}
        aria-label={ariaLabel as string}
      >
        {!avoidAutoEllipsis ? (
          <AutoEllipsis
            overrideStyles={(el) => {
              const td = el.closest('td') as HTMLElement;

              return {
                width: window.getComputedStyle(td).width,
              };
            }}
          >
            {props.children ?? cell.children}
          </AutoEllipsis>
        ) : (
          (props.children ?? cell.children)
        )}
      </Box>
    );
  },
);
NoMemoDefaultCellRenderer.displayName = 'DefaultCellRenderer';
export const DefaultCellRenderer = NoMemoDefaultCellRenderer;
